<script setup>
import { useLayout2NewReleasesStore } from "@/modules/Layout2/stores/useLayout2NewReleases.store";
// import HomeMainContentCard from "./partials/HomeMainContentCard.vue";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import HomeMainContentCard from "./partials/HomeMainContentCard.vue";

const newReleasesStore = useLayout2NewReleasesStore();
const { loadingNewReleases, newReleases } = storeToRefs(newReleasesStore);

const comingSoonCourses = ref([
  {
    name: "Internet First Response",
    thumbnail:
      "https://webinarinc-v2-development.s3-us-west-2.amazonaws.com/units/4977/68319551dbb047596648f37f84037e80.png",
  },
  {
    name: "Inbound Call Guide",
    thumbnail:
      "https://i.vimeocdn.com/video/1404898266-2f9cdb0d8c547d855e031b1a16b829b0fbb594bbdb770430ddddbf6dc9039a9e-d_640",
  },
  {
    name: "Unsold Showroom Traffic",
    thumbnail:
      "https://webinarinc-v2-development.s3-us-west-2.amazonaws.com/units/67/f4f094d90aeec96d557300b8366d6dd3.png",
  },
  {
    name: "Long Term Follow Up",
    thumbnail:
      "https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/units/2112/ef95a0001103967ba6841343638dbaa1.png",
  },
  {
    name: "Service Acquisition",
    thumbnail: "https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/units/432/vPVJm4uJpdpbUayzfRO0.jpg"
  }
]);
</script>
<template>
  <div class="w-full">
    <ul
      role="list"
      class="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3"
      v-if="!loadingNewReleases"
    >
      <li class="col-span-1" v-for="release in newReleases" :key="release.id">
        <HomeMainContentCard :content="release" />
      </li>
      <li
        v-for="(comingSoon, index) in comingSoonCourses"
        :key="index"
        class="col-span-1 flex justify-center items-center"
      >
        <div
          class="w-full h-72 shadow-lg shadow-brand/75 border-brand-light flex flex-col rounded-md relative overflow-hidden"
        >
          <img :src="comingSoon.thumbnail" class="w-full object-cover object-center min-h-56 h-full" />
          <div
            class="flex flex-col gap-1 w-full p-2 flex-1 bg-untitled-gray-100 justify-center text-center items-center text-sm font-semibold text-untitled-gray-600"
          >
            <span>{{ comingSoon.name }}</span>
          </div>
          <div
            class="absolute top-0 right-0 w-full h-full bg-untitled-gray-600 bg-opacity-60 flex justify-center items-center text-center"
          >
            <span
              class="uppercase text-xl sm:text-2xl md:text-3xl lg:text-5xl text-untitled-gray-200 font-semibold -rotate-12  text-center"
              >Coming Soon</span
            >
          </div>
        </div>
      </li>
    </ul>
    <div
      class="w-full flex justify-center items-center lg:min-h-72 h-72 border border-brand-light/20 rounded-md"
      v-if="!loadingNewReleases && !newReleases.length && false"
    >
      <h1 class="font-semibold text-sm text-brand/40">
        No New Releases Available
      </h1>
    </div>
    <ul
      role="list"
      v-if="loadingNewReleases"
      class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3"
    >
      <li
        class="col-span-1 h-72 bg-brand/10 flex flex-col overflow-hidden rounded-md"
        v-for="n in 9"
        :key="n"
      >
        <div class="w-full flex-1 bg-brand/20 animate-pulse" />
        <div class="w-full h-20"></div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped></style>
